import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-audit-trail',
  templateUrl: './bulk-audit-trail.component.html',
  styleUrls: ['./bulk-audit-trail.component.scss']
})
export class BulkAuditTrailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
